import { useEffect, useState } from 'react'
import { Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row, Table, } from "reactstrap";
import fileDownload from 'js-file-download';

import { API_ENDPOINTS } from "./api";
import { start } from "service";
import { BackgroundColorContext } from 'contexts/BackgroundColorContext';
import { INPUT } from 'Auth/config';
import { CabeceraFormulariosTratamiento, InputUsuario, Select1Aux, Select1, ComponenteCheck_, InputUsuarioXS, ComponenteCheckTratamiento, InputUsuarioStandarNumeros, ComponenteInputRadio, CabeceraFormulariosTratamientoLista, } from './input/elementos';
import { saveDB } from 'service';
import toast from 'react-hot-toast';
import { editDB } from 'service';
import { eliminarDB } from 'service';
import { fichaPDF } from 'pdfMake/ficha';
import { ComponenteInputBuscar_ } from './input/elementos';
import { buscarDB } from 'service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faFolderPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';



export default function Ficha() {




  const [lista, setLista] = useState([])
  const [listaSemana, setListaSemana] = useState([])

  const [modalRegistrar, setModalRegistrar] = useState(false)
  const [modalEdit, setModalEdit] = useState(false)
  const [inputBuscar, setInputBuscar] = useState({ campo: null, valido: null })



  const [id, setId] = useState({ campo: null, valido: null })
  const [fechaNac, setFechaNac] = useState()

  const [observacion, setObservacion] = useState({ campo: null, valido: null })

  const [estadoEnvio, setEstadoEnvio] = useState(0);




  const [idSemana, setIdSemana] = useState({ campo: null, valido: null })
  const [semana, setSemana] = useState({ campo: null, valido: null })
  const [numero, setNumero] = useState({ campo: null, valido: null })
  const [notificacion, setNotificacion] = useState({ campo: null, valido: null })
  const [sexo, setSexo] = useState(null)

  const [mujerEmbarazada, setMujerEmbarazada] = useState(false)
  const [fum, setFum] = useState({ campo: null, valido: null })
  const [tutorMenorEdad, setTutorMenorEdad] = useState({ campo: null, valido: null })

  // antecedentes patologicos

  const [transfusionSangre, setTransfusionSangre] = useState(false)
  const [madreSerologica, setMadreSerologica] = useState(false)
  const [tuboTransplante, setTuboTransplante] = useState(false)
  const [carneMalCocida, setCarneMalCocida] = useState(false)
  const [otraInformacion, setOtraInformacion] = useState({ campo: null, valido: null })

  //RESIDENCIA DEL PACIENTE
  const [otroPaisResidencia, setOtroPaisResidencia] = useState(false)
  const [idDepartamentoResidencia, setIdDepartamentoResidencia] = useState({ campo: null, valido: null })
  const [departamentoResidencia, setDepartamentoResidencia] = useState({ campo: null, valido: null })
  const [idRedResidencia, setIdRedResidencia] = useState({ campo: null, valido: null })
  const [redResidencia, setRedResidencia] = useState({ campo: null, valido: null })
  const [idMunicipioResidencia, setIdMunicipioResidencia] = useState({ campo: null, valido: null })
  const [municipioResidencia, setMunicipioResidencia] = useState({ campo: null, valido: null })
  const [comunidadResidencia, setComunidadResidencia] = useState({ campo: null, valido: null })
  const [permanenciaResidencia, setPermanenciaResidencia] = useState(false)
  const [añosResidencia, setAñosResidencia] = useState({ campo: 0, valido: 'true' })
  const [mesesResidencia, setMesesResidencia] = useState({ campo: 0, valido: 'true' })
  const [diasResidencia, setDiasResidencia] = useState({ campo: 0, valido: 'true' })

  // antecedentes epidemiologicos
  const [otroPaisEpidemica, setOtroPaisEpidemica] = useState(false)
  const [viveZonaEndemica, setViveZonaEndemica] = useState(false)
  const [idDepartamentoEndemica, setIdDepartamentoEndemica] = useState({ campo: null, valido: null })
  const [departamentoEndemica, setDepartamentoEndemica] = useState({ campo: null, valido: null })
  const [idRedEndemica, setIdRedEndemica] = useState({ campo: null, valido: null })
  const [redEndemica, setRedEndemica] = useState({ campo: null, valido: null })
  const [idMunicipioEndemica, setIdMunicipioEndemica] = useState({ campo: null, valido: null })
  const [municipioEndemica, setMunicipioEndemica] = useState({ campo: null, valido: null })
  const [comunidadEndemica, setComunidadEndemica] = useState({ campo: null, valido: null })
  const [barrioEndemica, setBarrioEndemica] = useState({ campo: null, valido: null })

  // DATOS CLINICOS


  // FASE AGUDA

  const [fechaInicioSintomasAgudas, setFechaInicioSintomasAgudas] = useState({ campo: null, valido: null })

  const [asintomaticoAgudo, setAsintomaticoAgudo] = useState(false)
  const [fiebreMayor7dias, setFiebreMayor7dias] = useState(false)
  const [chagomaInoculacion, setChagomaInoculacion] = useState(false)
  const [signoRomaña, setSignoRomaña] = useState(false)
  const [adenopatia, setAdenopatia] = useState(false)
  const [irritabilidad, setIrritabilidad] = useState(false)
  const [diarreas, setDiarreas] = useState(false)
  const [hepatoesplenomegalia, setHepatoesplenomegalia] = useState(false)
  const [convulsiones, setConvulsiones] = useState(false)
  const [otrosSintomasAgudos, setOtrosSintomasAgudos] = useState({ campo: null, valido: null })

  // FASE CRONICA
  const [fechaInicioSintomasCronicas, setFechaInicioSintomasCronicas] = useState({ campo: null, valido: null })
  const [asintomaticoCronico, setAsintomaticoCronico] = useState(false)

  const [alteracionesCardiacas, setAlteracionesCardiacas] = useState(false)
  const [alteracionesDigestivas, setAlteracionesDigestivas] = useState(false)
  const [alteracionesNerviosas, setAlteracionesNerviodsas] = useState(false)
  const [alteracionesAnedopatia, setAlteracionesAnedopatia] = useState(false)
  const [otrosSintomasCronicas, setOtrosSintomasCronicas] = useState({ campo: null, valido: null })

  // FORMA DE TRANSMISION
  const [oral, setOral] = useState(false)
  const [vectorial, setVectorial] = useState(false)
  const [congenito, setCongenito] = useState(false)
  const [transfucional, setTransfucioal] = useState(false)
  const [transplante, setTransplante] = useState(false)
  const [otrasTransmisiones, setOtrasTransmisiones] = useState({ campo: null, valido: null })

  // clasificacion del caso


  const [agudo, setAgudo] = useState(true)
  const [cronico, setCronico] = useState(false)


  const [idPaciente, setIdPaciente] = useState();
  const [nombrePaciente, setNombrePaciente] = useState();
  const [ci, setCi] = useState();
  const [ciTutor, setCiTutor] = useState();


  // consultas

  const [listaDepto, setListaDepto] = useState([])
  const [listaRed, setListaRed] = useState([])
  const [listaMunicipio, setListaMunicipio] = useState([])


  useEffect(() => {
    const ini = () => {
      document.title = "FICHA";
      listar()
    }
    ini()
    return () => { }
  }, []);

  useEffect(() => {
    if (inputBuscar.campo?.length === 0) listar()
  }, [inputBuscar])





  const listar = async () => {
    try {
      const data = await start(API_ENDPOINTS.FICHA.LISTAR)
      setLista(data)
    } catch (error) {

    }
  };


  const listarParametros = async () => {
    try {
      const loadingToast = toast.loading('Cargando parámetros...');
      const data = await start(API_ENDPOINTS.FICHA.LISTAR_PARAMETROS)
      toast.dismiss(loadingToast);

      if (data[0]?.length > 0) {
        setListaSemana(data[0])
      }
      if (data[1]?.length > 0) {
        setListaDepto(data[1])
      }
    } catch (error) {
      toast.error("Error al obtener las fichas")
    }
  };


  const opciones = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const initialFormState = {
    campo: null,
    valido: null
  };
  const vaciarDatos = () => {
    const fieldsToReset = {
      setObservacion,
    };
    Object.values(fieldsToReset).forEach(setterFn => {
      setterFn(initialFormState);
    });

    setModalEdit(false);
    setModalRegistrar(false);
  };

  const buscar = async () => {
    if (inputBuscar.valido === "true") {
      const data = await buscarDB(API_ENDPOINTS.FICHA.BUSCAR, { dato: inputBuscar.campo })
      toast.success(data.length > 0 ? 'Informacion encontrada..' : 'lista vacia')
      setLista(data)
    }
  }

  const insertar = async () => {
    // alert(comunidadResidencia.campo)

    let edad_años = 0
    let edad_meses = 0
    let edad_dias = 0

    let edadBD = fechaNac
    let hoy = new Date();
    let fechaDeNacimiento = new Date(edadBD);
    edad_años = hoy.getFullYear() - fechaDeNacimiento.getFullYear();;
    edad_meses = hoy.getMonth() - fechaDeNacimiento.getMonth();
    edad_dias = hoy.getDate() - fechaDeNacimiento.getDate();

    if (edad_dias < 0) {
      const mesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
      edad_dias += mesAnterior.getDate();
      edad_meses--;
    }

    if (edad_meses < 0) {
      edad_años--;
      edad_meses += 12;
    }



    if (estadoEnvio === 0) {
      setEstadoEnvio(1);
      await saveDB(API_ENDPOINTS.FICHA.REGISTRAR, {

        //total variable: 68

        // DATOS PACIENTE
        id_paciente: idPaciente,
        nombre_paciente: nombrePaciente,
        ci,
        ci_tutor: ciTutor,
        edad_años,
        edad_meses,
        edad_dias,
        // grupo1 formaulario

        notificacion: notificacion.campo,
        id_semana: idSemana.campo,
        semana: semana.campo,
        numero: numero.campo,
        mujerEmbarazada,
        fum: fum.campo,
        tutorMenorEdad: tutorMenorEdad.campo,

        //Antecedentes Patologicos
        transfusionSangre,
        madreSerologica,
        tuboTransplante,
        carneMalCocida,
        otraInformacion: otraInformacion.campo,

        //RESIDENCIA ACTUAL DEL PACIENTE
        otroPaisResidencia,
        idDepartamentoResidencia: idDepartamentoResidencia.campo,
        departamentoResidencia: departamentoResidencia.campo,
        idRedResidencia: idRedResidencia.campo,
        redResidencia: redResidencia.campo,
        idMunicipioResidencia: idMunicipioResidencia.campo,
        municipioResidencia: municipioResidencia.campo,
        comunidadResidencia: comunidadResidencia.campo,
        diasResidencia: diasResidencia.campo,
        mesesResidencia: mesesResidencia.campo,
        añosResidencia: añosResidencia.campo,
        permanenciaResidencia,

        //ANTECEDENTES EPIDEMIOLÓGICOS
        otroPaisEpidemica,
        viveZonaEndemica,
        idDepartamentoEndemica: idDepartamentoEndemica.campo,
        departamentoEndemica: departamentoEndemica.campo,
        idRedEndemica: idRedEndemica.campo,
        redEndemica: redEndemica.campo,
        idMunicipioEndemica: idMunicipioEndemica.campo,
        municipioEndemica: municipioEndemica.campo,
        comunidadEndemica: comunidadEndemica.campo,
        barrioEndemica: barrioEndemica.campo,

        //DATOS CLÍNICOS - CLASIFICACIÓN DE CASO
        //FASE AGUDA
        fechaInicioSintomasAgudas: fechaInicioSintomasAgudas.campo,
        asintomaticoAgudo,
        fiebreMayor7dias,
        chagomaInoculacion,
        signoRomaña,
        adenopatia,
        irritabilidad,
        diarreas,
        hepatoesplenomegalia,
        convulsiones,
        otrosSintomasAgudos: otrosSintomasAgudos.campo,

        // FASE CRÓNICA
        fechaInicioSintomasCronicas: fechaInicioSintomasCronicas.campo,
        asintomaticoCronico,
        alteracionesCardiacas,
        alteracionesDigestivas,
        alteracionesNerviosas,
        alteracionesAnedopatia,
        otrosSintomasCronicas: otrosSintomasCronicas.campo,

        //FORMA DE TRANSMISIÓN
        oral,
        vectorial,
        congenito,
        transfucional,
        transplante,
        otrasTransmisiones: otrasTransmisiones.campo,

        // CLASIFICACIÓN DEL CASO
        agudo,
        cronico,

        observacion: observacion.campo,
      }, setModalRegistrar, setEstadoEnvio, false, vaciarDatos)
      listar()
    } else toast.error("FORMULARIO YA ENVIADO");
  };

  const editar = async () => {

    let edad_años = 0
    let edad_meses = 0
    let edad_dias = 0

    let edadBD = fechaNac
    let hoy = new Date();
    let fechaDeNacimiento = new Date(edadBD);
    edad_años = hoy.getFullYear() - fechaDeNacimiento.getFullYear();;
    edad_meses = hoy.getMonth() - fechaDeNacimiento.getMonth();
    edad_dias = hoy.getDate() - fechaDeNacimiento.getDate();

    if (edad_dias < 0) {
      const mesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
      edad_dias += mesAnterior.getDate();
      edad_meses--;
    }

    if (edad_meses < 0) {
      edad_años--;
      edad_meses += 12;
    }

    await editDB(API_ENDPOINTS.FICHA.MODIFICAR, {
      id: id.campo,
      //total variable: 68

      //total variable: 68

      // DATOS PACIENTE
      id_paciente: idPaciente,
      nombre_paciente: nombrePaciente,
      ci,
      ci_tutor: ciTutor,
      edad_años,
      edad_meses,
      edad_dias,
      // grupo1 formaulario

      notificacion: notificacion.campo,
      id_semana: idSemana.campo,
      semana: semana.campo,
      numero: numero.campo,
      mujerEmbarazada,
      fum: fum.campo,
      tutorMenorEdad: tutorMenorEdad.campo,

      //Antecedentes Patologicos
      transfusionSangre,
      madreSerologica,
      tuboTransplante,
      carneMalCocida,
      otraInformacion: otraInformacion.campo,

      //RESIDENCIA ACTUAL DEL PACIENTE
      otroPaisResidencia,
      idDepartamentoResidencia: idDepartamentoResidencia.campo,
      departamentoResidencia: departamentoResidencia.campo,
      idRedResidencia: idRedResidencia.campo,
      redResidencia: redResidencia.campo,
      idMunicipioResidencia: idMunicipioResidencia.campo,
      municipioResidencia: municipioResidencia.campo,
      comunidadResidencia: comunidadResidencia.campo,
      diasResidencia: diasResidencia.campo,
      mesesResidencia: mesesResidencia.campo,
      añosResidencia: añosResidencia.campo,
      permanenciaResidencia,

      //ANTECEDENTES EPIDEMIOLÓGICOS
      otroPaisEpidemica,
      viveZonaEndemica,
      idDepartamentoEndemica: idDepartamentoEndemica.campo,
      departamentoEndemica: departamentoEndemica.campo,
      idRedEndemica: idRedEndemica.campo,
      redEndemica: redEndemica.campo,
      idMunicipioEndemica: idMunicipioEndemica.campo,
      municipioEndemica: municipioEndemica.campo,
      comunidadEndemica: comunidadEndemica.campo,
      barrioEndemica: barrioEndemica.campo,

      //DATOS CLÍNICOS - CLASIFICACIÓN DE CASO
      //FASE AGUDA
      fechaInicioSintomasAgudas: fechaInicioSintomasAgudas.campo,
      asintomaticoAgudo,
      fiebreMayor7dias,
      chagomaInoculacion,
      signoRomaña,
      adenopatia,
      irritabilidad,
      diarreas,
      hepatoesplenomegalia,
      convulsiones,
      otrosSintomasAgudos: otrosSintomasAgudos.campo,

      // FASE CRÓNICA
      fechaInicioSintomasCronicas: fechaInicioSintomasCronicas.campo,
      asintomaticoCronico,
      alteracionesCardiacas,
      alteracionesDigestivas,
      alteracionesNerviosas,
      alteracionesAnedopatia,
      otrosSintomasCronicas: otrosSintomasCronicas.campo,

      //FORMA DE TRANSMISIÓN
      oral,
      vectorial,
      congenito,
      transfucional,
      transplante,
      otrasTransmisiones: otrasTransmisiones.campo,

      // CLASIFICACIÓN DEL CASO
      agudo,
      cronico,

      observacion: observacion.campo,
    }, setModalEdit, false, vaciarDatos)
    listar()
  };


  const eliminar = async (ficha) => {
    if (window.confirm('Eliminar Tratamiento ?')) {
      await eliminarDB(API_ENDPOINTS.FICHA.ELIMINAR, { ficha })
      listar()
    }
  }

  const exportPdf = async (output, ficha, paciente) => {
    const data = await start(API_ENDPOINTS.FICHA.VER_PDF, { ficha, paciente })

    const response = await fichaPDF(output, { ficha: data[0], paciente: data[1], listaItemsLaboratorio: data[2] })

    if (!response?.success) {
      alert(response?.message);
      return;
    }

    if (output === "b64") {
      const b64toBlob = (
        b64Data,
        contentType = "",
        sliceSize = 512
      ) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(
            offset,
            offset + sliceSize
          );

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };
      const blob = b64toBlob(response.content, "application/pdf");
      fileDownload(blob, "Ficha-Epidemiologica.pdf");
    }
  }

  return (
    <>

      <div className="contentSimple"  >
        <div className="main-container">
          <Card>
            <CabeceraFormulariosTratamientoLista />
            <CardBody>
              <div className="pt-2 pl-0">
                <ComponenteInputBuscar_
                  estado={inputBuscar}
                  cambiarEstado={setInputBuscar}
                  name="inputBuscar"
                  ExpresionRegular={INPUT.INPUT_BUSCAR}  //expresion regular
                  placeholder="Escriba para filtrar ..."
                  eventoBoton={buscar}
                  etiqueta={'Buscar'}
                />
              </div>

              <Table className="tablesorter" responsive >
                <BackgroundColorContext.Consumer>
                  {({ color }) => (
                    <thead className="text-primary" data={color}>
                      <tr>
                        <th >PACIENTE</th>
                        <th >C.I.</th>
                        <th >TUTOR</th>
                        <th >FECHA NOTIFICACION</th>
                        <th >SEMANA EPIDEMIOLOGICA</th>
                        <th >DEPARTAMENTO RES.</th>
                        <th >MUNICIPIO RES.</th>
                        <th >COMUNIDAD RES.</th>
                        <th >ESTABLECIMIENTO FICHA</th>
                        <th ></th>
                      </tr>
                    </thead>
                  )}
                </BackgroundColorContext.Consumer>
                <tbody >
                  {lista.map((a, index) => (
                    <tr key={a.id} style={{
                      height: '50px', background: index % 2 == 0 ? "#E1EEF4" : 'white',
                      color: index % 2 == 0 ? "#00496B" : 'white'
                    }} className='item'>
                      <td><div className="tbl-des">{a.paciente}</div></td>
                      <td><div className="tbl-des">{a.ci}</div></td>
                      <td><div className="tbl-des">{a.tutor}</div></td>
                      <td><div className="tbl-des">{a.notificacion}</div></td>
                      <td><div className="tbl-des">{a.semana}</div></td>
                      <td><div className="tbl-des">{a.departamentoResidencia}</div></td>
                      <td><div className="tbl-des">{a.municipioResidencia}</div></td>
                      <td><div className="tbl-des">{a.comunidadResidencia}</div></td>
                      <td><div className="tbl-des">{a.hospital}</div></td>
                      <td>
                        <div className="btn-tbl-container row">
                          {a.edicion &&
                            parseInt(localStorage.getItem('numRol')) == 5  ?
                              <>

                                <div

                                  className="btn-tbl col-3 bg-info"
                                  onClick={async () => {
                                    setFechaNac(a.fecha_nac)

                                    const data = await start(API_ENDPOINTS.FICHA.OBTENER_FICHA, { ficha: a.id_ficha })
                                    data.forEach(async (a) => {

                                      const dataRed = await start(API_ENDPOINTS.FICHA.LISTAR_REDES, { depto: a.idDepartamentoResidencia })
                                      setListaRed(dataRed)

                                      const dataMunicipio = await start(API_ENDPOINTS.FICHA.LISTAR_MUNICIPIOS, { red: a.idRedResidencia })
                                      setListaMunicipio(dataMunicipio)


                                      setId({ campo: a.id, valido: true })
                                      setIdPaciente(a.id_paciente)
                                      setNombrePaciente(a.nombre_paciente)
                                      setCi(a.ci)
                                      setCiTutor(a.ci_tutor)
                                      setIdSemana({ campo: a.id_semana, valido: true })
                                      setSemana({ campo: a.semana, valido: true })
                                      setNumero({ campo: a.numero, valido: true })
                                      setNotificacion({ campo: a.notificacion?.split('T')[0], valido: true })
                                      setFum({ campo: a.fum, valido: true })
                                      setTutorMenorEdad({ campo: a.tutorMenorEdad, valido: true })
                                      setOtraInformacion({ campo: a.otraInformacion, valido: true })
                                      setIdDepartamentoResidencia({ campo: a.idDepartamentoResidencia, valido: true })
                                      setDepartamentoResidencia({ campo: a.departamentoResidencia, valido: true })
                                      setIdRedResidencia({ campo: a.idRedResidencia, valido: true })
                                      setRedResidencia({ campo: a.redResidencia, valido: true })
                                      setIdMunicipioResidencia({ campo: a.idMunicipioResidencia, valido: true })
                                      setMunicipioResidencia({ campo: a.municipioResidencia, valido: true })
                                      setComunidadResidencia({ campo: a.comunidadResidencia, valido: true })
                                      setDiasResidencia({ campo: a.diasResidencia, valido: true })
                                      setMesesResidencia({ campo: a.mesesResidencia, valido: true })
                                      setAñosResidencia({ campo: a.añosResidencia, valido: true })

                                      setIdDepartamentoEndemica({ campo: a.idDepartamentoEndemica, valido: true })


                                      setDepartamentoEndemica({ campo: a.departamentoEndemica, valido: true })
                                      setIdRedEndemica({ campo: a.idRedEndemica, valido: true })


                                      setRedEndemica({ campo: a.redEndemica, valido: true })
                                      setIdMunicipioEndemica({ campo: a.idMunicipioEndemica, valido: true })
                                      setMunicipioEndemica({ campo: a.municipioEndemica, valido: true })
                                      setComunidadEndemica({ campo: a.comunidadEndemica, valido: true })
                                      setBarrioEndemica({ campo: a.barrioEndemica, valido: true })
                                      setFechaInicioSintomasAgudas({ campo: a.fechaInicioSintomasAgudas?.split('T')[0], valido: true })
                                      setOtrosSintomasAgudos({ campo: a.otrosSintomasAgudos, valido: true })
                                      setFechaInicioSintomasCronicas({ campo: a.fechaInicioSintomasCronicas?.split('T')[0], valido: true })
                                      setOtrosSintomasCronicas({ campo: a.otrosSintomasCronicas, valido: true })
                                      setOtrasTransmisiones({ campo: a.otrasTransmisiones, valido: true })
                                      setObservacion({ campo: a.observacion, valido: true })
                                      setMujerEmbarazada(a.mujerEmbarazada)
                                      setTransfusionSangre(a.transfusionSangre)
                                      setMadreSerologica(a.madreSerologica)
                                      setTuboTransplante(a.tuboTransplante)
                                      setCarneMalCocida(a.carneMalCocida)
                                      setPermanenciaResidencia(a.permanenciaResidencia)
                                      setViveZonaEndemica(a.viveZonaEndemica)
                                      setAsintomaticoAgudo(a.asintomaticoAgudo)
                                      setFiebreMayor7dias(a.fiebreMayor7dias)
                                      setChagomaInoculacion(a.chagomaInoculacion)
                                      setSignoRomaña(a.signoRomaña)
                                      setAdenopatia(a.adenopatia)
                                      setIrritabilidad(a.irritabilidad)
                                      setDiarreas(a.diarreas)
                                      setHepatoesplenomegalia(a.hepatoesplenomegalia)
                                      setConvulsiones(a.convulsiones)
                                      setAsintomaticoCronico(a.asintomaticoCronico)
                                      setAlteracionesCardiacas(a.alteracionesCardiacas)
                                      setAlteracionesDigestivas(a.alteracionesDigestivas)
                                      setAlteracionesNerviodsas(a.alteracionesNerviosas)
                                      setAlteracionesAnedopatia(a.alteracionesAnedopatia)
                                      setOral(a.oral)
                                      setVectorial(a.vectorial)
                                      setCongenito(a.congenito)
                                      setTransfucioal(a.transfucional)
                                      setTransplante(a.transplante)
                                      setAgudo(a.agudo)
                                      setCronico(a.cronico)
                                    })
                                    listarParametros()
                                    setModalEdit(true)
                                  }}><FontAwesomeIcon icon={faEdit}></FontAwesomeIcon></div>
                                <div
                                  onClick={() => eliminar(a.id_ficha)}
                                  className="btn-tbl col-3  ml-1" style={{ background: '#FF3D85' }}><FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                                </div>
                              </> : null}
                          {a.id_ficha > 0 ?
                            < div onClick={() => { exportPdf(window.innerWidth < 1100 ? 'b64' : "print", a.id_ficha, a.id_paciente) }}
                              className="btn-tbl btn-success col-3  ml-1 " style={{ background: '#00d084' }} ><FontAwesomeIcon icon={faEye}></FontAwesomeIcon></div> : null}
                        
                          {a.id_ficha < 1 && parseInt(localStorage.getItem('numRol')) == 5 ?
                            <div
                              className="btn-tbl col-3 bg-info"
                              onClick={() => {
                                listarParametros()
                                setIdPaciente(a.id_paciente)
                                setFechaNac(a.fecha_nac)
                                setNombrePaciente(a.paciente)
                                setCi(a.ci)
                                setCiTutor(a.ci_tutor)
                                if (parseInt(a.sexo) == 1) setSexo(1)
                                if (parseInt(a.sexo) == 2) setSexo(2)
                                setModalRegistrar(true)
                              }}
                            >
                              <FontAwesomeIcon icon={faFolderPlus}></FontAwesomeIcon>
                            </div>
                            : null}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {lista.length < 1 && (
                <div class="text-success text-center" style={{ fontSize: "18px" }}>Lista Vacia</div>
              )}
            </CardBody>
          </Card>
        </div >
      </div >


      <Modal
        isOpen={modalRegistrar}
        toggle={() => setModalRegistrar(!modalRegistrar)}
        className="modal-lgmd"
      >
        <ModalHeader
          toggle={() => setModalRegistrar(!modalRegistrar)}
        ></ModalHeader>
        <ModalBody>

          <CabeceraFormulariosTratamiento />

          <div className=' row' style={{ marginBottom: '1rem' }}>
            <Col md={2}>
              <InputUsuario
                estado={notificacion}
                cambiarEstado={setNotificacion}
                name={'notificacion'}
                ExpresionRegular={INPUT.FECHA}
                tipo={'date'}
                etiqueta={'Fecha Notificacion'}
                msg={"El formato no es válido"}
              />
            </Col>

            <Col md={3}>
              <Select1Aux
                estado={idSemana}
                cambiarEstado={setIdSemana}
                lista={listaSemana}
                name={'semana'}
                ExpresionRegular={INPUT.ID}
                label={setSemana}
                etiqueta={'Semana Epidemiológica'}
                msg={"El formato no es válido"}
              />
            </Col>

            <Col md={2}>
              <InputUsuarioStandarNumeros
                estado={numero}
                cambiarEstado={setNumero}
                name={'numero'}
                ExpresionRegular={INPUT.NUMEROS_P}
                etiqueta={'Código'}
                label={semana}
                msg={"El formato no es válido"}
              />
            </Col>

          </div>
          {sexo == 2 &&
            <div className=' row' style={{ marginBottom: '1rem' }}>
              <ComponenteCheckTratamiento
                label='Si es mujer, ¿esta embarazada?'
                label_A='SI'
                label_B='NO'
                estado={mujerEmbarazada}
                cambiarEstado={setMujerEmbarazada}
              />

              <Col md={4}>
                <InputUsuario
                  estado={fum}
                  cambiarEstado={setFum}
                  name={'fum'}
                  ExpresionRegular={INPUT.FECHA}
                  tipo={'date'}
                  importante={false}
                  etiqueta={'Fecha ultima menstruación FUM'}
                  msg={"El formato no es válido"}
                />
              </Col>
            </div>
          }

          <InputUsuarioXS
            estado={tutorMenorEdad}
            cambiarEstado={setTutorMenorEdad}
            name={'tutor_menor_de_edad'}
            ExpresionRegular={INPUT.TEXT}
            etiqueta={'En caso de que el paciente sea menor de edad, datos del padre o tutor: '}
            msg={"El formato no es válido"}
            importante={false}
          />

          <div className='cabecera-form'>
            <p> Antecedentes Patologicos</p>
          </div>

          <div className='row' style={{ justifyItems: 'revert-layer' }}>
            <ComponenteCheckTratamiento
              label='Recibió transfusión de sangre? '
              label_A='SI'
              label_B='NO'
              estado={transfusionSangre}
              cambiarEstado={setTransfusionSangre}
              col={2}
            />

            <ComponenteCheckTratamiento
              label='Nacio de madre con serología (+) para Chagas '
              label_A='SI'
              label_B='NO'
              estado={madreSerologica}
              cambiarEstado={setMadreSerologica}
              col={3}

            />

            <ComponenteCheckTratamiento
              label='Tuvo trasplante de Órgano '
              label_A='SI'
              label_B='NO'
              estado={tuboTransplante}
              cambiarEstado={setTuboTransplante}
              col={2}
            />
            <ComponenteCheckTratamiento
              label='Consumio carne de animal mal cocida? (Amazonia) '
              label_A='SI'
              label_B='NO'
              estado={carneMalCocida}
              cambiarEstado={setCarneMalCocida}
              col={4}
            />

          </div>

          <InputUsuarioXS
            estado={otraInformacion}
            cambiarEstado={setOtraInformacion}
            name={'otro_patologico'}
            ExpresionRegular={INPUT.TEXT}
            etiqueta={'Otro: '}
            msg={"El formato no es válido"}
            importante={false}

          />

          <div className='cabecera-form' style={{ marginBottom: '8px' }}>
            <p>RESIDENCIA ACTUAL DEL PACIENTE</p>
          </div>
          <ComponenteCheck_

            name={'otro_pais_residencia'}
            label={'OTRO PAIS DE RESIDENCIA'}
            estado={otroPaisResidencia}
            cambiarEstado={setOtroPaisResidencia}
          />
          {otroPaisResidencia ?
            <div className='row' >
              <Col lg={2} style={{ marginTop: '8px' }}>
                <InputUsuario
                  estado={departamentoResidencia}
                  cambiarEstado={setDepartamentoResidencia}
                  name={'depto_residencia'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Pais / Departamento: '}
                  msg={"El formato no es válido"}
                  importante={true}
                />
              </Col>
              <Col lg={2} style={{ marginTop: '8px' }}>
                <InputUsuario
                  estado={municipioResidencia}
                  cambiarEstado={setMunicipioResidencia}
                  name={'municipio_residencia'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Municipio: '}
                  msg={"El formato no es válido"}
                  importante={true}
                />
              </Col>
              <Col lg={3} style={{ marginTop: '8px' }}>
                <InputUsuario
                  estado={comunidadResidencia}
                  cambiarEstado={setComunidadResidencia}
                  name={'comunidad_residencia'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Distrito/Localidad/comunidad: '}
                  msg={"El formato no es válido"}
                  importante={true}
                />
              </Col>
              <Col lg={5}>
                <div className='row'>
                  <Col md={5} style={{ marginTop: '4px' }}>
                    <div className='row'>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={diasResidencia}
                          cambiarEstado={setDiasResidencia}
                          name={'dia_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Días: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={mesesResidencia}
                          cambiarEstado={setMesesResidencia}
                          name={'mes_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Meses: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={añosResidencia}
                          cambiarEstado={setAñosResidencia}
                          name={'años_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Años: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                    </div>
                  </Col>
                  <Col md={7}>
                    <ComponenteCheckTratamiento
                      label={'Permanencia'}
                      label_A='Temporal'
                      label_B='Indefinido'
                      estado={permanenciaResidencia}
                      cambiarEstado={setPermanenciaResidencia}
                      col={12}
                    />
                  </Col>
                </div>
              </Col>
            </div>
            :
            <div className='row' >
              <Col md={3}
                style={{ marginTop: '3' }}>
                <Select1
                  estado={idDepartamentoResidencia}
                  cambiarEstado={setIdDepartamentoResidencia}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'Departamento'}
                  msg={"el formato no es valido"}
                  lista={listaDepto}
                  label={setDepartamentoResidencia}
                  name={'departamento_residencia'}
                  funcion={async (depto) => {
                    const data = await start(API_ENDPOINTS.FICHA.LISTAR_REDES, { depto })
                    setListaRed(data)
                  }}
                />
              </Col>
              <Col md={3}
                style={{ marginTop: '3' }}>
                <Select1
                  estado={idRedResidencia}
                  cambiarEstado={setIdRedResidencia}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'red'}
                  msg={"el formato no es valido"}
                  lista={listaRed}
                  label={setRedResidencia}
                  name={'red_residencia'}
                  funcion={async (red) => {
                    const data = await start(API_ENDPOINTS.FICHA.LISTAR_MUNICIPIOS, { red })
                    setListaMunicipio(data)
                  }}
                />
              </Col>
              <Col md={3}
                style={{ marginTop: '3' }}>
                <Select1
                  estado={idMunicipioResidencia}
                  cambiarEstado={setIdMunicipioResidencia}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'municipio'}
                  msg={"el formato no es valido"}
                  lista={listaMunicipio}
                  label={setMunicipioResidencia}
                  name={'municipio_residencia'}
                />
              </Col>

              <Col lg={3} style={{ marginTop: '7px' }}>
                <InputUsuario
                  estado={comunidadResidencia}
                  cambiarEstado={setComunidadResidencia}
                  name={'comunidad_residencia'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Barrio/comunidad: '}
                  msg={"El formato no es válido"}
                  importante={true}
                />
              </Col>
              <Col lg={7}>
                <div className='row'>
                  <Col md={5} style={{ marginTop: '4px' }}>
                    <div className='row'>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={diasResidencia}
                          cambiarEstado={setDiasResidencia}
                          name={'dia_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Días: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={mesesResidencia}
                          cambiarEstado={setMesesResidencia}
                          name={'mes_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Meses: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={añosResidencia}
                          cambiarEstado={setAñosResidencia}
                          name={'años_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Años: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                    </div>
                  </Col>
                  <Col md={7}>
                    <ComponenteCheckTratamiento
                      label={'Permanencia'}
                      label_A='Temporal'
                      label_B='Indefinido'
                      estado={permanenciaResidencia}
                      cambiarEstado={setPermanenciaResidencia}
                      col={12}
                    />
                  </Col>
                </div>
              </Col>

            </div>
          }
          <div className='cabecera-form' style={{ marginBottom: '8px' }}>
            <p>ANTECEDENTES EPIDEMIOLÓGICOS</p>
          </div>
          <ComponenteCheck_
            name={'otro_pais_epidemica'}
            label={'OTRO PAIS DE ENDEMICA'}
            estado={otroPaisEpidemica}
            cambiarEstado={setOtroPaisEpidemica}

          />
          {otroPaisEpidemica ?
            <div className='row'>
              <Col md={3}>
                <ComponenteCheckTratamiento
                  label={'Vive o visito zona endémica para Chagas?'}
                  label_A='SI'
                  label_B='NO'
                  estado={viveZonaEndemica}
                  cambiarEstado={setViveZonaEndemica}
                  col={12}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>
                <InputUsuario
                  estado={departamentoEndemica}
                  cambiarEstado={setDepartamentoEndemica}
                  name={'depto_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Departamento: '}
                  msg={"El formato no es válido"}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>
                <InputUsuario
                  estado={municipioEndemica}
                  cambiarEstado={setMunicipioEndemica}
                  name={'municipio_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Municipio: '}
                  msg={"El formato no es válido"}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={3} style={{ marginTop: '5px' }}>
                <InputUsuario
                  estado={comunidadEndemica}
                  cambiarEstado={setComunidadEndemica}
                  name={'comunidad_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Distrito/Localidad/comunidad: '}
                  msg={"El formato no es válido"}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>
                <InputUsuario
                  estado={barrioEndemica}
                  cambiarEstado={setBarrioEndemica}
                  name={'comunidad_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Barrio/Zona/ U.V.: '}
                  msg={"El formato no es válido"}
                  importante={false}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
            </div>
            :
            <div className='row'>
              <Col md={3} style={{ marginTop: '3px' }}>
                <ComponenteCheckTratamiento
                  label={'Vive o visito zona endémica para Chagas?'}
                  label_A='SI'
                  label_B='NO'
                  estado={viveZonaEndemica}
                  cambiarEstado={setViveZonaEndemica}
                  col={12}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>
                <Select1
                  estado={idDepartamentoEndemica}
                  cambiarEstado={setIdDepartamentoEndemica}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'Departamento'}
                  msg={"el formato no es valido"}
                  lista={listaDepto}
                  label={setDepartamentoEndemica}
                  name={'departamento_endemica'}
                  funcion={async (depto) => {
                    const data = await start(API_ENDPOINTS.FICHA.LISTAR_REDES, { depto })
                    setListaRed(data)
                  }}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>

                <Select1
                  estado={idRedEndemica}
                  cambiarEstado={setIdRedEndemica}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'red'}
                  msg={"el formato no es valido"}
                  lista={listaRed}
                  label={setRedEndemica}
                  name={'red_endemica'}
                  funcion={async (red) => {
                    const data = await start(API_ENDPOINTS.FICHA.LISTAR_MUNICIPIOS, { red })
                    setListaMunicipio(data)
                  }}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={3} style={{ marginTop: '5px' }}>
                <Select1
                  estado={idMunicipioEndemica}
                  cambiarEstado={setIdMunicipioEndemica}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'municipio'}
                  msg={"el formato no es valido"}
                  lista={listaMunicipio}
                  label={setMunicipioEndemica}
                  name={'municipio_residencia'}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={2} style={{ marginTop: '9px' }}>
                <InputUsuario
                  estado={barrioEndemica}
                  cambiarEstado={setBarrioEndemica}
                  name={'comunidad_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Barrio/Zona/ U.V.: '}
                  msg={"El formato no es válido"}
                  importante={false}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
            </div>}

          <div className='cabecera-form mt-4'>
            <p>DATOS CLÍNICOS - CLASIFICACIÓN DE CASO</p>
          </div>
          <p style={{ marginBottom: '0' }}>(Marque con una X los signos y síntomas que presenta el/la paciente)</p>
          <div className='cabecera-form' style={{ marginTop: '0' }}>
            <p>FASE AGUDA</p>
          </div>
          <Col md={4}>
            <InputUsuario
              estado={fechaInicioSintomasAgudas}
              cambiarEstado={setFechaInicioSintomasAgudas}
              name={'fecha_inicio_sintomas'}
              ExpresionRegular={INPUT.FECHA}
              tipo={'date'}
              importante={false}
              etiqueta={'Fecha fecha inicio sintomas'}
              msg={"El formato no es válido"}
            />
          </Col>

          <div className='row'>

            <Col md={2} >
              <ComponenteCheck_
                name={'asintomatico_agudo'}
                label={'Asintomático'}
                estado={asintomaticoAgudo}
                cambiarEstado={setAsintomaticoAgudo}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'fiebre_Mayor_7dias_agudo'}
                label={'Fiebre > a 7 dias'}
                estado={fiebreMayor7dias}
                cambiarEstado={setFiebreMayor7dias}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'chagoma_inoculacion_agudo'}
                label={'Chagoma de Inoculacion'}
                estado={chagomaInoculacion}
                cambiarEstado={setChagomaInoculacion}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'signo_de_omaña_agudo'}
                label={'Chagoma de Inoculacion'}
                estado={signoRomaña}
                cambiarEstado={setSignoRomaña}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'adenopatia_agudo'}
                label={'Adenopatia'}
                estado={adenopatia}
                cambiarEstado={setAdenopatia}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'irritabilidad_agudo'}
                label={'Irritabilidad'}
                estado={irritabilidad}
                cambiarEstado={setIrritabilidad}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'diarreas_agudo'}
                label={'Diarreas'}
                estado={diarreas}
                cambiarEstado={setDiarreas}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'hepatoesplenomegalia_agudo'}
                label={'hepatoesplenomegalia'}
                estado={hepatoesplenomegalia}
                cambiarEstado={setHepatoesplenomegalia}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'convulsiones_agudo'}
                label={'convulsiones'}
                estado={convulsiones}
                cambiarEstado={setConvulsiones}
              />
            </Col>
            <Col md={6} >
              <InputUsuarioXS
                name={'otros_sintomas_agudo'}
                etiqueta={'Otros'}
                estado={otrosSintomasAgudos}
                cambiarEstado={setOtrosSintomasAgudos}
                importante={false}
              />
            </Col>
          </div>

          <div className='cabecera-form' style={{ marginTop: '0' }}>
            <p>FASE CRÓNICA</p>
          </div>
          <Col md={4}>
            <InputUsuario
              estado={fechaInicioSintomasCronicas}
              cambiarEstado={setFechaInicioSintomasCronicas}
              name={'fecha_inicio_sintomas_cronicas'}
              ExpresionRegular={INPUT.FECHA}
              tipo={'date'}
              importante={false}
              etiqueta={'Fecha fecha inicio sintomas'}
              msg={"El formato no es válido"}
            />
          </Col>
          <div className='row'>
            <Col md={1} >
              <ComponenteCheck_
                name={'asintomatico_cronica'}
                label={'Asintomático'}
                estado={asintomaticoCronico}
                cambiarEstado={setAsintomaticoCronico}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'alteraciones_cardiacasa'}
                label={'Alt. Cardiacas '}
                estado={alteracionesCardiacas}
                cambiarEstado={setAlteracionesCardiacas}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'alteraciones_digestivas_cronica'}
                label={'Alt. Digestivas'}
                estado={alteracionesDigestivas}
                cambiarEstado={setAlteracionesDigestivas}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'alteraciones_nerviosas_cronica'}
                label={'Alt. Sistema Nervioso'}
                estado={alteracionesNerviosas}
                cambiarEstado={setAlteracionesNerviodsas}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'alteraciones_adenopatia_cronica'}
                label={'Adenopatia'}
                estado={alteracionesAnedopatia}
                cambiarEstado={setAlteracionesAnedopatia}
              />
            </Col>

            <Col md={3} >
              <InputUsuarioXS
                name={'otros_sintomas_cronicas'}
                etiqueta={'Otros'}
                estado={otrosSintomasCronicas}
                cambiarEstado={setOtrosSintomasCronicas}
                importante={false}
              />
            </Col>
          </div>




          <div className='cabecera-form mt-3'>
            <p>FORMA DE TRANSMISIÓN</p>
          </div>

          <div className='row'>
            <Col md={1} >
              <ComponenteCheck_
                name={'oral'}
                label={'Oral'}
                estado={oral}
                cambiarEstado={setOral}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'vectorial'}
                label={'Vectorial'}
                estado={vectorial}
                cambiarEstado={setVectorial}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'congenito'}
                label={'congenito'}
                estado={congenito}
                cambiarEstado={setCongenito}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'transfucional'}
                label={'Transfucional'}
                estado={transfucional}
                cambiarEstado={setTransfucioal}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'transplante'}
                label={'transplante'}
                estado={transplante}
                cambiarEstado={setTransplante}
              />
            </Col>

            <Col md={3} >
              <InputUsuarioXS
                name={'otras_transmisiones'}
                etiqueta={'Otros'}
                estado={otrasTransmisiones}
                cambiarEstado={setOtrasTransmisiones}
                importante={false}
              />
            </Col>
          </div>



          <div className='cabecera-form mt-3'>
            <p>CLASIFICACIÓN DEL CASO</p>
          </div>

          <div className='row' style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <Col md={4} >
              <ComponenteCheck_
                name={'agudo'}
                label={'agudo'}
                estado={agudo}
                f2={setCronico}
                cambiarEstado={setAgudo}
              />
            </Col>
            <Col md={4} >
              <ComponenteCheck_
                name={'cronico'}
                label={'cronico'}
                estado={cronico}
                f2={setAgudo}
                cambiarEstado={setCronico}
              />
            </Col>
          </div>



          <InputUsuarioXS
            estado={observacion}
            cambiarEstado={setObservacion}
            ExpresionRegular={INPUT.TEXT}
            etiqueta={'Observaciones:'}
            msg={"El formato no es válido"}
            name={'observaciones'}
            importante={false}
          />
          <p style={{ color: '#f5365c', fontSize: '11px' }}>
            Todo paciente con dos pruebas serológicas positivos se considera para hacer tratamiento
          </p>

          <div style={{ display: 'flex', justifyContent: 'center', padding: '1px 0px' }} >
            <div className="hero-section m-1 mt-3 mb-3" >
              <button onClick={() => insertar()} className="btn btn-success" >Registrar</button>
            </div>
          </div>
        </ModalBody>
      </Modal >




      <Modal
        isOpen={modalEdit}
        toggle={() => setModalEdit(!modalEdit)}
        className="modal-lgmd"
      >
        <ModalHeader
          toggle={() => setModalEdit(!modalEdit)}
        >
          EDITAR TRATAMIENTO
        </ModalHeader>
        <ModalBody>

          <CabeceraFormulariosTratamiento />


          <CabeceraFormulariosTratamiento />

          <div className=' row' style={{ marginBottom: '1rem' }}>
            <Col md={2}>
              <InputUsuario
                estado={notificacion}
                cambiarEstado={setNotificacion}
                name={'notificacion'}
                ExpresionRegular={INPUT.FECHA}
                tipo={'date'}
                etiqueta={'Fecha Notificacion'}
                msg={"El formato no es válido"}
              />
            </Col>

            <Col md={3}>
              <Select1Aux
                estado={idSemana}
                cambiarEstado={setIdSemana}
                lista={listaSemana}
                name={'semana'}
                ExpresionRegular={INPUT.ID}
                label={setSemana}
                etiqueta={'Semana Epidemiológica'}
                msg={"El formato no es válido"}
              />
            </Col>

            <Col md={2}>
              <InputUsuarioStandarNumeros
                estado={numero}
                cambiarEstado={setNumero}
                name={'numero'}
                ExpresionRegular={INPUT.NUMEROS_P}
                etiqueta={'Número'}
                label={semana}
                msg={"El formato no es válido"}
              />
            </Col>

          </div>
          {sexo == 2 &&
            <div className=' row' style={{ marginBottom: '1rem' }}>
              <ComponenteCheckTratamiento
                label='Si es mujer, ¿esta embarazada?'
                label_A='SI'
                label_B='NO'
                estado={mujerEmbarazada}
                cambiarEstado={setMujerEmbarazada}
              />

              <Col md={4}>
                <InputUsuario
                  estado={fum}
                  cambiarEstado={setFum}
                  name={'fum'}
                  ExpresionRegular={INPUT.FECHA}
                  tipo={'date'}
                  importante={false}
                  etiqueta={'Fecha ultima menstruación FUM'}
                  msg={"El formato no es válido"}
                />
              </Col>
            </div>
          }

          <InputUsuarioXS
            estado={tutorMenorEdad}
            cambiarEstado={setTutorMenorEdad}
            name={'tutor_menor_de_edad'}
            ExpresionRegular={INPUT.TEXT}
            etiqueta={'En caso de que el paciente sea menor de edad, datos del padre o tutor: '}
            msg={"El formato no es válido"}
            importante={false}
          />

          <div className='cabecera-form'>
            <p> Antecedentes Patologicos</p>
          </div>

          <div className='row' style={{ justifyItems: 'revert-layer' }}>
            <ComponenteCheckTratamiento
              label='Recibió transfusión de sangre? '
              label_A='SI'
              label_B='NO'
              estado={transfusionSangre}
              cambiarEstado={setTransfusionSangre}
              col={2}
            />

            <ComponenteCheckTratamiento
              label='Nacio de madre con serología (+) para Chagas '
              label_A='SI'
              label_B='NO'
              estado={madreSerologica}
              cambiarEstado={setMadreSerologica}
              col={3}

            />

            <ComponenteCheckTratamiento
              label='Tuvo trasplante de Órgano '
              label_A='SI'
              label_B='NO'
              estado={tuboTransplante}
              cambiarEstado={setTuboTransplante}
              col={2}
            />
            <ComponenteCheckTratamiento
              label='Consumio carne de animal mal cocida? (Amazonia) '
              label_A='SI'
              label_B='NO'
              estado={carneMalCocida}
              cambiarEstado={setCarneMalCocida}
              col={4}
            />

          </div>

          <InputUsuarioXS
            estado={otraInformacion}
            cambiarEstado={setOtraInformacion}
            name={'otro_patologico'}
            ExpresionRegular={INPUT.TEXT}
            etiqueta={'Otro: '}
            msg={"El formato no es válido"}
            importante={false}

          />

          <div className='cabecera-form' style={{ marginBottom: '8px' }}>
            <p>RESIDENCIA ACTUAL DEL PACIENTE</p>
          </div>
          <ComponenteCheck_

            name={'otro_pais_residencia'}
            label={'OTRO PAIS DE RESIDENCIA'}
            estado={otroPaisResidencia}
            cambiarEstado={setOtroPaisResidencia}
          />
          {otroPaisResidencia ?
            <div className='row' >
              <Col lg={2} style={{ marginTop: '8px' }}>
                <InputUsuario
                  estado={departamentoResidencia}
                  cambiarEstado={setDepartamentoResidencia}
                  name={'depto_residencia'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Pais / Departamento: '}
                  msg={"El formato no es válido"}
                  importante={true}
                />
              </Col>
              <Col lg={2} style={{ marginTop: '8px' }}>
                <InputUsuario
                  estado={municipioResidencia}
                  cambiarEstado={setMunicipioResidencia}
                  name={'municipio_residencia'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Municipio: '}
                  msg={"El formato no es válido"}
                  importante={true}
                />
              </Col>
              <Col lg={3} style={{ marginTop: '8px' }}>
                <InputUsuario
                  estado={comunidadResidencia}
                  cambiarEstado={setComunidadResidencia}
                  name={'comunidad_residencia'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Distrito/Localidad/comunidad: '}
                  msg={"El formato no es válido"}
                  importante={true}
                />
              </Col>
              <Col lg={5}>
                <div className='row'>
                  <Col md={5} style={{ marginTop: '4px' }}>
                    <div className='row'>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={diasResidencia}
                          cambiarEstado={setDiasResidencia}
                          name={'dia_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Días: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={mesesResidencia}
                          cambiarEstado={setMesesResidencia}
                          name={'mes_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Meses: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={añosResidencia}
                          cambiarEstado={setAñosResidencia}
                          name={'años_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Años: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                    </div>
                  </Col>
                  <Col md={7}>
                    <ComponenteCheckTratamiento
                      label={'Permanencia'}
                      label_A='Temporal'
                      label_B='Indefinido'
                      estado={permanenciaResidencia}
                      cambiarEstado={setPermanenciaResidencia}
                      col={12}
                    />
                  </Col>
                </div>
              </Col>
            </div>
            :
            <div className='row' >
              <Col md={3}
                style={{ marginTop: '3' }}>
                <Select1
                  estado={idDepartamentoResidencia}
                  cambiarEstado={setIdDepartamentoResidencia}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'Departamento'}
                  msg={"el formato no es valido"}
                  lista={listaDepto}
                  label={setDepartamentoResidencia}
                  name={'departamento_residencia'}
                  funcion={async (depto) => {
                    const data = await start(API_ENDPOINTS.FICHA.LISTAR_REDES, { depto })
                    setListaRed(data)
                  }}
                />
              </Col>
              <Col md={3}
                style={{ marginTop: '3' }}>
                <Select1
                  estado={idRedResidencia}
                  cambiarEstado={setIdRedResidencia}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'red'}
                  msg={"el formato no es valido"}
                  lista={listaRed}
                  label={setRedResidencia}
                  name={'red_residencia'}
                  funcion={async (red) => {
                    const data = await start(API_ENDPOINTS.FICHA.LISTAR_MUNICIPIOS, { red })
                    setListaMunicipio(data)
                  }}
                />
              </Col>
              <Col md={3}
                style={{ marginTop: '3' }}>
                <Select1
                  estado={idMunicipioResidencia}
                  cambiarEstado={setIdMunicipioResidencia}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'municipio'}
                  msg={"el formato no es valido"}
                  lista={listaMunicipio}
                  label={setMunicipioResidencia}
                  name={'municipio_residencia'}
                />
              </Col>

              <Col lg={3} style={{ marginTop: '7px' }}>
                <InputUsuario
                  estado={comunidadResidencia}
                  cambiarEstado={setComunidadResidencia}
                  name={'comunidad_residencia'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Barrio/comunidad: '}
                  msg={"El formato no es válido"}
                  importante={true}
                />
              </Col>
              <Col lg={7}>
                <div className='row'>
                  <Col md={5} style={{ marginTop: '4px' }}>
                    <div className='row'>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={diasResidencia}
                          cambiarEstado={setDiasResidencia}
                          name={'dia_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Días: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={mesesResidencia}
                          cambiarEstado={setMesesResidencia}
                          name={'mes_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Meses: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                      <Col md={4}>
                        <InputUsuarioStandarNumeros
                          estado={añosResidencia}
                          cambiarEstado={setAñosResidencia}
                          name={'años_residencia'}
                          ExpresionRegular={INPUT.NUMEROS_P}
                          etiqueta={'Años: '}
                          msg={"El formato no es válido"}
                        />
                      </Col>
                    </div>
                  </Col>
                  <Col md={7}>
                    <ComponenteCheckTratamiento
                      label={'Permanencia'}
                      label_A='Temporal'
                      label_B='Indefinido'
                      estado={permanenciaResidencia}
                      cambiarEstado={setPermanenciaResidencia}
                      col={12}
                    />
                  </Col>
                </div>
              </Col>

            </div>
          }
          <div className='cabecera-form' style={{ marginBottom: '8px' }}>
            <p>ANTECEDENTES EPIDEMIOLÓGICOS</p>
          </div>
          <ComponenteCheck_
            name={'otro_pais_epidemica'}
            label={'OTRO PAIS DE ENDEMICA'}
            estado={otroPaisEpidemica}
            cambiarEstado={setOtroPaisEpidemica}

          />
          {otroPaisEpidemica ?
            <div className='row'>
              <Col md={3}>
                <ComponenteCheckTratamiento
                  label={'Vive o visito zona endémica para Chagas?'}
                  label_A='SI'
                  label_B='NO'
                  estado={viveZonaEndemica}
                  cambiarEstado={setViveZonaEndemica}
                  col={12}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>
                <InputUsuario
                  estado={departamentoEndemica}
                  cambiarEstado={setDepartamentoEndemica}
                  name={'depto_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Departamento: '}
                  msg={"El formato no es válido"}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>
                <InputUsuario
                  estado={municipioEndemica}
                  cambiarEstado={setMunicipioEndemica}
                  name={'municipio_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Municipio: '}
                  msg={"El formato no es válido"}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={3} style={{ marginTop: '5px' }}>
                <InputUsuario
                  estado={comunidadEndemica}
                  cambiarEstado={setComunidadEndemica}
                  name={'comunidad_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Distrito/Localidad/comunidad: '}
                  msg={"El formato no es válido"}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>
                <InputUsuario
                  estado={barrioEndemica}
                  cambiarEstado={setBarrioEndemica}
                  name={'comunidad_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Barrio/Zona/ U.V.: '}
                  msg={"El formato no es válido"}
                  importante={false}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
            </div>
            :
            <div className='row'>
              <Col md={3} style={{ marginTop: '3px' }}>
                <ComponenteCheckTratamiento
                  label={'Vive o visito zona endémica para Chagas?'}
                  label_A='SI'
                  label_B='NO'
                  estado={viveZonaEndemica}
                  cambiarEstado={setViveZonaEndemica}
                  col={12}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>
                <Select1
                  estado={idDepartamentoEndemica}
                  cambiarEstado={setIdDepartamentoEndemica}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'Departamento'}
                  msg={"el formato no es valido"}
                  lista={listaDepto}
                  label={setDepartamentoEndemica}
                  name={'departamento_endemica'}
                  funcion={async (depto) => {
                    const data = await start(API_ENDPOINTS.FICHA.LISTAR_REDES, { depto })
                    setListaRed(data)
                  }}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={2} style={{ marginTop: '5px' }}>

                <Select1
                  estado={idRedEndemica}
                  cambiarEstado={setIdRedEndemica}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'red'}
                  msg={"el formato no es valido"}
                  lista={listaRed}
                  label={setRedEndemica}
                  name={'red_endemica'}
                  funcion={async (red) => {
                    const data = await start(API_ENDPOINTS.FICHA.LISTAR_MUNICIPIOS, { red })
                    setListaMunicipio(data)
                  }}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={3} style={{ marginTop: '5px' }}>
                <Select1
                  estado={idMunicipioEndemica}
                  cambiarEstado={setIdMunicipioEndemica}
                  ExpresionRegular={INPUT.ID}
                  etiqueta={'municipio'}
                  msg={"el formato no es valido"}
                  lista={listaMunicipio}
                  label={setMunicipioEndemica}
                  name={'municipio_residencia'}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
              <Col md={2} style={{ marginTop: '9px' }}>
                <InputUsuario
                  estado={barrioEndemica}
                  cambiarEstado={setBarrioEndemica}
                  name={'comunidad_endemica'}
                  ExpresionRegular={INPUT.TEXT}
                  etiqueta={'Barrio/Zona/ U.V.: '}
                  msg={"El formato no es válido"}
                  importante={false}
                  disabled={viveZonaEndemica ? false : true}
                />
              </Col>
            </div>}

          <div className='cabecera-form mt-4'>
            <p>DATOS CLÍNICOS - CLASIFICACIÓN DE CASO</p>
          </div>
          <p style={{ marginBottom: '0' }}>(Marque con una X los signos y síntomas que presenta el/la paciente)</p>
          <div className='cabecera-form' style={{ marginTop: '0' }}>
            <p>FASE AGUDA</p>
          </div>
          <Col md={4}>
            <InputUsuario
              estado={fechaInicioSintomasAgudas}
              cambiarEstado={setFechaInicioSintomasAgudas}
              name={'fecha_inicio_sintomas'}
              ExpresionRegular={INPUT.FECHA}
              tipo={'date'}
              importante={false}
              etiqueta={'Fecha fecha inicio sintomas'}
              msg={"El formato no es válido"}
            />
          </Col>

          <div className='row'>

            <Col md={2} >
              <ComponenteCheck_
                name={'asintomatico_agudo'}
                label={'Asintomático'}
                estado={asintomaticoAgudo}
                cambiarEstado={setAsintomaticoAgudo}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'fiebre_Mayor_7dias_agudo'}
                label={'Fiebre > a 7 dias'}
                estado={fiebreMayor7dias}
                cambiarEstado={setFiebreMayor7dias}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'chagoma_inoculacion_agudo'}
                label={'Chagoma de Inoculacion'}
                estado={chagomaInoculacion}
                cambiarEstado={setChagomaInoculacion}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'signo_de_omaña_agudo'}
                label={'Chagoma de Inoculacion'}
                estado={signoRomaña}
                cambiarEstado={setSignoRomaña}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'adenopatia_agudo'}
                label={'Adenopatia'}
                estado={adenopatia}
                cambiarEstado={setAdenopatia}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'irritabilidad_agudo'}
                label={'Irritabilidad'}
                estado={irritabilidad}
                cambiarEstado={setIrritabilidad}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'diarreas_agudo'}
                label={'Diarreas'}
                estado={diarreas}
                cambiarEstado={setDiarreas}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'hepatoesplenomegalia_agudo'}
                label={'hepatoesplenomegalia'}
                estado={hepatoesplenomegalia}
                cambiarEstado={setHepatoesplenomegalia}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'convulsiones_agudo'}
                label={'convulsiones'}
                estado={convulsiones}
                cambiarEstado={setConvulsiones}
              />
            </Col>
            <Col md={6} >
              <InputUsuarioXS
                name={'otros_sintomas_agudo'}
                etiqueta={'Otros'}
                estado={otrosSintomasAgudos}
                cambiarEstado={setOtrosSintomasAgudos}
                importante={false}
              />
            </Col>
          </div>

          <div className='cabecera-form' style={{ marginTop: '0' }}>
            <p>FASE CRÓNICA</p>
          </div>
          <Col md={4}>
            <InputUsuario
              estado={fechaInicioSintomasCronicas}
              cambiarEstado={setFechaInicioSintomasCronicas}
              name={'fecha_inicio_sintomas_cronicas'}
              ExpresionRegular={INPUT.FECHA}
              tipo={'date'}
              importante={false}
              etiqueta={'Fecha fecha inicio sintomas'}
              msg={"El formato no es válido"}
            />
          </Col>
          <div className='row'>
            <Col md={1} >
              <ComponenteCheck_
                name={'asintomatico_cronica'}
                label={'Asintomático'}
                estado={asintomaticoCronico}
                cambiarEstado={setAsintomaticoCronico}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'alteraciones_cardiacasa'}
                label={'Alt. Cardiacas '}
                estado={alteracionesCardiacas}
                cambiarEstado={setAlteracionesCardiacas}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'alteraciones_digestivas_cronica'}
                label={'Alt. Digestivas'}
                estado={alteracionesDigestivas}
                cambiarEstado={setAlteracionesDigestivas}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'alteraciones_nerviosas_cronica'}
                label={'Alt. Sistema Nervioso'}
                estado={alteracionesNerviosas}
                cambiarEstado={setAlteracionesNerviodsas}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'alteraciones_adenopatia_cronica'}
                label={'Adenopatia'}
                estado={alteracionesAnedopatia}
                cambiarEstado={setAlteracionesAnedopatia}
              />
            </Col>

            <Col md={3} >
              <InputUsuarioXS
                name={'otros_sintomas_cronicas'}
                etiqueta={'Otros'}
                estado={otrosSintomasCronicas}
                cambiarEstado={setOtrosSintomasCronicas}
                importante={false}
              />
            </Col>
          </div>




          <div className='cabecera-form mt-3'>
            <p>FORMA DE TRANSMISIÓN</p>
          </div>

          <div className='row'>
            <Col md={1} >
              <ComponenteCheck_
                name={'oral'}
                label={'Oral'}
                estado={oral}
                cambiarEstado={setOral}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'vectorial'}
                label={'Vectorial'}
                estado={vectorial}
                cambiarEstado={setVectorial}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'congenito'}
                label={'congenito'}
                estado={congenito}
                cambiarEstado={setCongenito}
              />
            </Col>

            <Col md={2} >
              <ComponenteCheck_
                name={'transfucional'}
                label={'Transfucional'}
                estado={transfucional}
                cambiarEstado={setTransfucioal}
              />
            </Col>
            <Col md={2} >
              <ComponenteCheck_
                name={'transplante'}
                label={'transplante'}
                estado={transplante}
                cambiarEstado={setTransplante}
              />
            </Col>

            <Col md={3} >
              <InputUsuarioXS
                name={'otras_transmisiones'}
                etiqueta={'Otros'}
                estado={otrasTransmisiones}
                cambiarEstado={setOtrasTransmisiones}
                importante={false}
              />
            </Col>
          </div>



          <div className='cabecera-form mt-3'>
            <p>CLASIFICACIÓN DEL CASO</p>
          </div>

          <div className='row' style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <Col md={4} >
              <ComponenteCheck_
                name={'agudo'}
                label={'agudo'}
                estado={agudo}
                f2={setCronico}
                cambiarEstado={setAgudo}
              />
            </Col>
            <Col md={4} >
              <ComponenteCheck_
                name={'cronico'}
                label={'cronico'}
                estado={cronico}
                f2={setAgudo}
                cambiarEstado={setCronico}
              />
            </Col>
          </div>

          <InputUsuarioXS
            estado={observacion}
            cambiarEstado={setObservacion}
            ExpresionRegular={INPUT.TEXT}
            etiqueta={'Observaciones:'}
            msg={"El formato no es válido"}
            name={'observaciones'}
            importante={false}
          />
          <p style={{ color: '#f5365c', fontSize: '11px' }}>
            Todo paciente con dos pruebas serológicas positivos se considera para hacer tratamiento
          </p>

          <div style={{ display: 'flex', justifyContent: 'center', padding: '1px 0px' }} >
            <div className="hero-section m-1 mt-3 mb-3" >
              <button onClick={() => editar()} className="btn btn-success" >Editar</button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </ >
  );
}

